<template>
  <aside class="vision-mission-page">
    <DocumentPageTitle
      :word-count="totalWords"
      :word-limit="wordLimit"
      title="Vision, Mission, Values, Goals and Objectives"
    />

    <TextEditorInput
      v-for="storeItem in storeItems"
      :id="storeItem.id"
      :key="storeItem.id"
      v-model="planContentKey[storeItem.storeKey]"
      :label="storeItem.label"
      :word-limit="wordLimit"
      :total-word-count="totalWords"
      @update:word-count="handleWordCountUpdate"
    />
  </aside>
</template>

<script setup>
import { usePlanStore } from '@/store';
import { DocumentPageTitle } from '@/components/plan-document/components';
import { TextEditorInput } from '@/components/form-inputs';
import { useString, useTinyMCEWordCount } from '@/composables';
import { computed } from 'vue';

const planStore = usePlanStore();
const string = useString();

const wordLimit = 4800;

const planContentKey = computed(() => {
  return planStore.content?.vision || null;
});

const storeItems = [
  { storeKey: 'vision', label: 'Vision' },
  { storeKey: 'mission', label: 'Mission' },
  { storeKey: 'values', label: 'Values' },
  { storeKey: 'goals', label: 'Goals' },
  { storeKey: 'objectives', label: 'Objectives' },
].map(storeItem => ({ ...storeItem, id: string.sluggify(storeItem.label) }));

const storeItemIds = storeItems.map(storeItem => storeItem.id);

const {
  totalWords,
  updateCount,
} = useTinyMCEWordCount(wordLimit, storeItemIds);

const handleWordCountUpdate = ({ id, count }) => {
  updateCount(id, count);
};
</script>
